import { remember, serializeDataToCacheKey } from '@tuic/cache';
import { logger } from '@tuic/logger';

import { Pcl } from '../../index';
import { CacheTag } from '../../utils';

import type { Locale } from '@tuic/i18n';

/**
 * Fetches the ship decks from the PCL API.
 */
export const getShipDecks = async (
  shipCode: string,
  locale: Locale,
): Promise<Pcl.ShipDeck[]> => {
  const { data, error } = await Pcl.getShipsByShipCodeDecks({
    path: { shipCode },
    query: { locale },
  });

  if (error) {
    logger.error(
      `Could not fetch ship decks. Ship: ${shipCode}, Locale: ${locale}`,
    );
    logger.error(error);

    return [];
  }

  return data ?? [];
};

/**
 * Cached version of `getShipDecks`.
 */
export const cachedGetShipDecks = (
  shipCode: string,
  locale: Locale,
): Promise<Pcl.ShipDeck[]> =>
  remember(
    serializeDataToCacheKey([CacheTag.pcl, 'getShipDecks', locale, shipCode]),
    () => getShipDecks(shipCode, locale),
    {
      tags: [CacheTag.pcl, CacheTag.shipResource, CacheTag.getShipDecks],
      ttl: 600,
    },
  );
